<template>
  <section class="bg-white">
    <div class="container" v-if="safeHtmlContent" id="introduction">
      <h1
        class="mb-[10px] md:mb-6 text-xl md:text-2xl lg:text-[28px] lg:leading-[32px] text-secondary-dark font-OPPO-sans-m font-bold text-center uppercase break-words px-4 pt-14 md:pt-6"
        v-text="$t('common.product_introduction')"
      />
      <div
        class="max-w-[90%] lg:max-w-[80%] mx-auto text-base md:text-lg lg:text-xl text-center text-[#5A5A5A] font-OPPO-sans-regular"
        :class="{ fadedText: readMoreActive }"
        v-html="safeHtmlContent"
      />
      <div
        class="flex items-center justify-center w-full mt-2"
        v-if="readMoreActive"
      >
        <button
          v-if="readMoreToggle"
          class="w-auto flex font-bold text-center readMore focus:outline-none text-[#0080FF]"
          @click="readMore"
        >
          {{ $t("common.read_more") }}
          <AngleDown class="text-[#0080FF] w-6 h-6 ml-1" />
        </button>
        <button
          v-else
          class="w-auto flex font-bold text-center readLess focus:outline-none text-[#0080FF]"
          @click="readMore"
        >
          {{ $t("common.read_less") }}
          <AngleUp class="text-[#0080FF] w-6 h-6 ml-1" />
        </button>
      </div>
    </div>
  </section>
</template>

<script setup>
import AngleDown from "@/assets/svg/heroicons/angle-down.svg?component";
import AngleUp from "@/assets/svg/heroicons/angle-up.svg?component";
import DOMPurify from "dompurify";

const props = defineProps({
  productDescription: {
    type: String,
    required: true,
  },
});

const emit = defineEmits();

const readMoreActive = ref(props.productDescription.length >= 1500);
const readMoreToggle = ref(true);

const safeHtmlContent = computed(() => {
  if (props.productDescription && process.browser) {
    return DOMPurify.sanitize(props.productDescription);
  }
  return "";
});

onMounted(() => {
  emit("success");
});

function readMore() {
  const fadedText = document.querySelector(".fadedText");
  fadedText.classList.toggle("is-active");
  readMoreToggle.value = !readMoreToggle.value;
}
</script>

<style lang="postcss" scoped>
.fadedText {
  @apply max-h-[120px]
         w-full
         relative
         overflow-hidden;
  transition: all 0.3s linear;

  &::after {
    content: "";
    @apply h-[35px]
           block
           w-full
           absolute
           bottom-0;
  }
}

.fadedText.is-active {
  @apply max-h-screen;
}
</style>
